import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'

import {
  parentAuthLoginMutation,
  parentAuthLogoutMutation,
  parentAuthMeOptions,
  parentAuthMeQueryKey,
} from '@/client/@tanstack/react-query.gen'

// Single source of session truth: GET /api/me. Shared across ProtectedRoute, the
// app shell, and the login redirect — React Query dedupes it to one request.
export function useMe() {
  return useQuery({
    ...parentAuthMeOptions(),
    retry: false,
    staleTime: 5 * 60 * 1000,
  })
}

export function useLogin() {
  const queryClient = useQueryClient()
  return useMutation({
    ...parentAuthLoginMutation(),
    onSuccess: (account) => {
      // Login returns the Account, so seed the /me cache to flip ProtectedRoute
      // to authenticated without a second round-trip.
      queryClient.setQueryData(parentAuthMeQueryKey(), account)
    },
  })
}

export function useLogout() {
  const queryClient = useQueryClient()
  return useMutation({
    ...parentAuthLogoutMutation(),
    // Drop all cached session data whether or not the request succeeded — the
    // cookie is cleared server-side and the UI must fall back to /login either way.
    onSettled: () => {
      queryClient.clear()
    },
  })
}
